import { Action } from "../../../actions/actions";
import { ConfigurationsActionTypes } from "../actions/actionTypes";

export interface SchemaComponent {
    version: number;
    schema: any;
}

export interface ConfigurationSchema {
    components: { [key: string]: SchemaComponent };
    version: number;
    subsidiary: any;
}

export interface ProgressiveRulesSchema {
    type: number;
    prizes: number[];
    presets: {
        certified: boolean;
        prizes: any;
        type: string | number;
        id: string | number;
        name: string;
        stype: string | null;
        notes: string | null;
    }[];
}

export function schema(state: any = null, action: Action): ConfigurationSchema {
    switch (action.type) {
        case ConfigurationsActionTypes.GET_LATEST_SCHEMA_SUCCESS:
            return action.payload;
        case ConfigurationsActionTypes.CLEAR_SCHEMA:
            return null;
        default:
            return state;
    }
}

export function schemaLoading(state: boolean = true, action: Action): boolean {
    switch (action.type) {
        case ConfigurationsActionTypes.GET_LATEST_SCHEMA:
            return true;
        case ConfigurationsActionTypes.GET_LATEST_SCHEMA_SUCCESS:
        case ConfigurationsActionTypes.GET_LATEST_SCHEMA_FAIL:
            return false;
        default:
            return state;
    }
}

export function progressiveRules(
    state: ProgressiveRulesSchema[] = [],
    action: Action
): ProgressiveRulesSchema[] {
    switch (action.type) {
        case ConfigurationsActionTypes.GET_PROGRESSIVES_RULES_SUCCESS:
            return action.payload;
        default:
            return state;
    }
}
